import React from "react";
import WGLogo from "../images/welsh_gov_logo_black.svg";
import AlmaEconomicsLogo from "../images/alma_economics_logo.svg";
import "../css/styles.css";

function Header() {
	return (
		<div>
			<footer
				className="footer-container"
				style={{
					height: "100px !important",
					paddingTop: 0,
					paddingBottom: 0,
					borderTop: "none",
					borderBottom: " 10px solid #1f1f1f",
				}}
			>
				<div>
					<div className="footer-left-section">
						<a
							href="https://www.gov.wales/"
							target="_blank"
							rel="noreferrer"
						>
							<img src={WGLogo} alt="WG Logo" />
						</a>
					</div>
					<div className="footer-right-section">
						<a
							href="https://www.almaeconomics.com/"
							target="_blank"
							rel="noreferrer"
						>
							<img
								src={AlmaEconomicsLogo}
								alt="Alma Economics Logo"
							/>
						</a>
					</div>
				</div>
			</footer>
			<footer
				className="footer-container-mobile"
				style={{
					height: "100px !important",
					paddingTop: 15,
					paddingBottom: 15,
					borderTop: "none",
					borderBottom: " 10px solid #1f1f1f",
				}}
			>
				<div className="footer-logo-section">
					<div className="footer-left-section">
						<a
							href="https://www.gov.wales/"
							target="_blank"
							rel="noreferrer"
						>
							<img src={WGLogo} alt="WG Logo" />
						</a>
					</div>

					<div className="footer-right-section">
						<a
							href="https://www.almaeconomics.com/"
							target="_blank"
							rel="noreferrer"
						>
							<img
								src={AlmaEconomicsLogo}
								alt="Alma Economics Logo"
							/>
						</a>
					</div>
				</div>
			</footer>
		</div>
	);
}

export default Header;
